module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ag-grid-vue', {
    staticClass: "ag-theme-material",
    staticStyle: {
      "width": "40vw",
      "height": "60vh"
    },
    attrs: {
      "rowHeight": "45",
      "columnDefs": _vm.columnDefs,
      "rowData": _vm.rowData,
      "frameworkComponents": _vm.frameworkComponents,
      "context": _vm.context
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33448140","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/permissions/PermissionsTable.vue
// module id = 2039
// module chunks = 0